/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Found term
 */
export type Gsoa_Recommender_Term = {
    /**
     * The type of entity that corresponds to the term in terms of unambiguous mapping
     */
    Type?: Gsoa_Recommender_Term.Type;
    /**
     * Id entity that matches the term in terms of unambiguous mapping
     */
    ID?: string;
    /**
     * Vanr entity
     */
    Vanr?: string;
    /**
     * The text of the term found
     */
    Text?: string;
    /**
     * Last modified date description of entities that corresponds to the term as regards unambiguous mapping
     */
    LastChange?: string;
    /**
     * Store availability
     */
    Availability?: string;
};
export namespace Gsoa_Recommender_Term {
    /**
     * The type of entity that corresponds to the term in terms of unambiguous mapping
     */
    export enum Type {
        PRODUCT = 'Product',
        CATEGORY = 'Category',
        GENERALIZED_PRODUCT = 'GeneralizedProduct',
        COMMON_BRAND = 'CommonBrand',
    }
}

